// extracted by mini-css-extract-plugin
module.exports = {"Modal":"modal_Modal__DLDFe","anim":"modal_anim___5rAO"};